<template lang="pug">
batch-list.batch-update(
  :userRole='userRole',
  :currentLink='currentLink',
  :sideMenuLinkEvent='sideMenuLinkEvent',
  :logoutEvent='logoutEvent',
  :breadcrumbs='breadcrumbs',
  :batchButtonEvent='batchButtonEvent'
)
  template(#sideMenuSeparateText) 設定
  template(#logoutText) サインアウト
  template(#batchLabel) 個別成績表のインポート
  template(#batchButtonText) 更新
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import LoginMethods from '@/mixins/LoginMethods'
import StudyResultDetailsApi from '@/mixins/api/StudyResultDetailsApi'
import BatchList from '@/components/templates/manager/BatchList.vue'
import { breadcrumbType } from '@/models/breadcrumbModel'
import { LinkSetting, SideMenuSettings } from '@/const/SideMenuSettings'
import { UserRoles } from '@/const/UserRoles'

/**
 * システム管理者・バッチ更新画面
 */
@Component({
  components: {
    BatchList,
  },
})
export default class BatchUpdate extends Mixins(LoginMethods, StudyResultDetailsApi) {
  // パンくず
  private breadcrumbs: breadcrumbType[] = [
    {
      label: 'バッチ更新',
    },
  ]

  // システム管理者権限
  private userRole: UserRoles = UserRoles.ADMIN

  // サイドメニューの現在リンク
  private currentLink: LinkSetting = SideMenuSettings.MANAGER_BATCH

  // サイドメニュー遷移イベント
  private sideMenuLinkEvent(link: LinkSetting) {
    // 設定されたリンク先ページへ遷移
    this.$router.push({ name: `Admin${link.name}` })
  }

  // ログアウトイベント
  private logoutEvent() {
    this.logout()
    // ログインページへ遷移
    this.$router.push({ name: 'AdminLogin' })
  }

  // バッチボタン押下時イベント
  private async batchButtonEvent() {
    this.$loading.start()
    await this.execPaperTestResultsBatch()
    this.$loading.complete()
  }
}
</script>
